import { render, staticRenderFns } from "./DetailsEmail.vue?vue&type=template&id=56319d33"
import script from "./DetailsEmail.vue?vue&type=script&lang=js"
export * from "./DetailsEmail.vue?vue&type=script&lang=js"
import style0 from "./DetailsEmail.vue?vue&type=style&index=0&id=56319d33&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerIos,QVirtualScroll});
